import React from 'react';
import PropTypes from 'prop-types';

export const RadioButton = ({
    id = 'radio-button',
    initialValue = false,
    value,
    onClick,
    disabled = false,
    disabledStyle,
    activeStyle,
    inactiveStyle,
    checkStyle,
    ...props
}) => {
    const handleClick = () => {
        if (onClick && !disabled) onClick(id, !value);
    };

    if (value === undefined) value = initialValue;

    disabledStyle = {
        border: '1px solid #d7d7d7',
        backgroundColor: '#f4f4f4',
        cursor: 'default',
        ...disabledStyle
    };

    const style = {
        display: 'flex',
        boxSizing: 'border-box',
        height: 16,
        width: 16,
        borderRadius: 8,
        alignContent: 'center',
        alignSelf: 'center',
        border: '1px solid rgb(151,151,151)',
        backgroundColor: 'rgb(255,255,255)',
        justifyContent: 'center',
        cursor: 'pointer',
        ...props.style,
        ...(value ? activeStyle : inactiveStyle),
        ...(disabled ? disabledStyle : undefined)
    };

    checkStyle = {
        boxSizing: 'border-box',
        height: 6,
        width: 6,
        border: `2px solid rgb(${disabled ? '100,100,100' : '253,154,0'})`,
        backgroundColor: `rgb(${disabled ? '100,100,100' : '250,168,0'})`,
        borderRadius: 3,
        alignSelf: 'center',
        ...props.style,
        ...checkStyle
    };

    const RadioCheck = () => <div id={`${id}-check`} style={checkStyle} />;

    return (
        <div
            {...props}
            id={id}
            style={style}
            onClick={disabled ? undefined : handleClick}
        >
            {value ? <RadioCheck /> : null}
        </div>
    );
};

RadioButton.defaultProps = {
    id: 'radio-button',
    initialValue: false,
    disabled: false
};

RadioButton.propTypes = {
    id: PropTypes.string,
    initialValue: PropTypes.bool,
    value: PropTypes.any,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    activeStyle: PropTypes.object,
    inactiveStyle: PropTypes.object,
    disabledStyle: PropTypes.object,
    checkStyle: PropTypes.object,
    style: PropTypes.object
};

export default RadioButton;
